module.exports = __webpack_public_path__ + "static/img/pinan.235ff48.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/pinan.png
// module id = 9e3Y
// module chunks = 1